import type { SVGProps } from 'react';

const SvgPages = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="m19.71 7.29-4-4A1 1 0 0 0 15 3h-4C9.35 3 8 4.35 8 6v1H7c-1.65 0-3 1.35-3 3v8c0 1.65 1.35 3 3 3h6c1.65 0 3-1.35 3-3v-1h1c1.65 0 3-1.35 3-3V8c0-.27-.11-.52-.29-.71M14 18c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-8c0-.55.45-1 1-1h1v5c0 1.65 1.35 3 3 3h3zm4-4c0 .55-.45 1-1 1h-6c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h1v3c0 1.65 1.35 3 3 3h3zm0-5h-3c-.55 0-1-.45-1-1V5h.59L18 8.41z"
    />
  </svg>
);
export default SvgPages;
